import { getPlatform, getProductId } from '@/infrastructure/product-info';
import { DATONG_EVENT_NAME } from '@/infrastructure/reporter/datong/constant';
import { reporter } from '@/infrastructure/reporter/datong/index';
import { useStores } from '@/presentation/store';
import {
  reportDtClick,
  reportDtPgIn,
  reportDtPgOut,
  useDtReportPage,
} from '@raft/utils/src/datong';

/**
 * 页面切入上报
 * @param pgid
 */
export const reportPgIn = (pgid: string) => reportDtPgIn(reporter, {
  pgid,
  productId: getProductId(),
  rm_platform: getPlatform(),
});

/**
 * 页面切出上报
 * @param pgid
 * @param duration
 */
export const reportPgOut = (pgid: string, duration = 0) => reportDtPgOut(reporter, {
  pgid,
  custom_pgout_pgid: pgid,
  custom_pgout_duration: duration,
  productId: getProductId(),
  rm_platform: getPlatform(),
}, duration);

/**
 * 点击上报
 * @param module 一般情况下为 pgId
 * @param action
 * @param optional
 */
export const reportClick = (
  module: string,
  action: string,
  optional?: {
    from?: string,
    cost?: number,
    result?: number,
    param1?: number,
    param2?: number,
    param3?: string,
    param4?: string,
  },
) => reportDtClick(reporter, module, action, optional);

/**
 * 页面上报 hook
 * @param pgid
 */
export const useReportPage = (pgid: string) => {
  useStores().LayoutStore.setPgId(pgid);
  useDtReportPage(reporter, {
    pgid,
    productId: getProductId(),
    rm_platform: getPlatform(),
  });
};

/**
 * @deprecated 已废弃，使用 reportClick
 */
export const reportElement = (
  element: HTMLElement | string,
  pgid: string,
  eid: string,
  params: { [key: string]: string},
) => {
  reporter?.reportElement(element, {
    pgid,
    eventName: DATONG_EVENT_NAME.click,
    businessParams: {
      eid,
      ...params,
    },
  });
};
export enum ReportScene {
  BatteryList='电量异常分析',
  BatteryFactor='电量耗电因素',
  BatteryAnalytics='电量指标分析',
  ApplicationExitInfo= '进程退出分析',
  MallocList='内存分配列表',
  IOSFoomIssuesList='IOS的FOOM问题列表',
  ANRAnalytics='ANR指标分析',
  ANRIOSList='IOS的ANR问题列表',
  AbnormalExitInfo='异常退出分析',
  showModal='添加问题标签',
  showTrend='查看上报趋势',
  AlertLevelUp='告警升级',
  DataLabeling='数据过滤规则',
  WeightSetting='质量报告',
  Encryption='日志加密',
  ProDuctConfigDimension='自定义维度',
  ContinuousCrash='连续崩溃',
  ClusterConfig='Issue 聚类配置',
  PageDuration='页面性能',
  Decode='日志解码',
  Colouration='设备染色',
  TrafficAnalytics='流量指标分析',
  CommandDeliveryList='日志查询',
  TrafficList='流量异常分析',
  HTTP='HTTP',
  WithDropFrame='关联卡顿列表',
  FoomIssuesList='OOM问题列表',
  FoomAnalytics='OOM指标分析',
  DropFrameAnalytics='卡顿指标分析',
  DropFrameList='卡顿问题列表',
  DropFrameTree='卡顿树',
  MemoryAnalytics='内存指标分析',
  MemoryVcLeak='VC 内存泄漏',
  BadMalloc='大块内存分配',
  JavaLeakList='Java 内存泄漏',
  JavaMemoryDetail='Java 内存详情',
  MemoryDetail='内存详情',
  FdDetail='FD 详情',
  NativeDetail='Native 内存详情',
  BigPic='大图分析',
  LaunchAnalytics='启动指标分析',
  LaunchIssues='启动个例',
  NetError='网络错误',
  UploadSymbolList = '上传符号表',
  AppDeliverConfig = '配置任务',
  AlertFilter= '告警过滤条件',
  AlertCondition= '告警判异条件',
  MonitorFrequency='告警监控频率',
  AlertStatisticType='告警统计方式',
  MonitorMetric='告警维度',
  MonitorItem='告警监控项',
  CreateAlert='新建告警任务',
  OverViewTime='大盘指标的升级引导框',
  qualityReport='质量报告',
  dashboardVersion='版本指标',
  abTestVersion='业务下钻指标',
  dashboardUser='我的看板',
  dashboardProject='公共看板',
  DateCascaderQuick='时间选择器的快捷选项',
  TagStatisticalDistribution='问题标签分布',
  RanklistShowDetail='排行榜的查看更多',
  TrendDownLoad='下载趋势分析',
  Stacks='出错堆栈分析',
  AddCondition='添加条件',
  IssueList='问题列表',
  FilterArray='筛选字段',
  TimeWindow='聚合粒度',
  EnterCompare='条件对比',
  LogAnalyze='日志自动分析',
  IssueSplit='Issue拆分',
  RelatedMonitoring='联动监控',
  Tombstone='附件',
  MainStack='聚类堆栈',
  AnrMsg='ANR_INFO',
  AnrTrace='ANR Trace',
  FDInfo='FD信息',
  ProcessInfo='进程信息',
  Scheduling='调度时序图',
  GCDetail='GC详情',
  MiniDump='minidump',
  Dimension='现场数据-自定义维度',
  Page='现场数据-页面追踪',
  QimeiCount='上报设备',
  userCount='上报用户',
  AddSection='添加分布',
  BatchCreate='批量提单',
  Setting='字段分布的设置',
  Track='高级搜索',
  MetircKit='MetircKit',
  Tapd='Tapd',
  Trace='现场数据的页面跟踪',
  SectionList='区间分布'
}

export enum ReportField {
  AddCondition='添加条件',
  Stacks='出错堆栈分析',
  BatteryList='电量异常分析',
  BatteryFactor='电量耗电因素',
  BatteryAnalytics='电量指标分析',
  ApplicationExitInfo= '进程退出分析',
  MallocList='内存分配列表',
  IOSFoomIssuesList='IOS的FOOM问题列表',
  ANRAnalytics='ANR指标分析',
  ANRIOSList='IOS的ANR问题列表',
  AbnormalExitInfo='异常退出分析',
  showModal='添加问题标签',
  showTrend='查看上报趋势',
  AlertLevelUp='告警升级',
  DataLabeling='数据过滤规则',
  WeightSetting='质量报告',
  Encryption='日志加密',
  ProDuctConfigDimension='自定义维度',
  ContinuousCrash='连续崩溃',
  ClusterConfig='Issue 聚类配置',
  PageDuration='页面性能',
  Decode='日志解码',
  Colouration='设备染色',
  CommandDeliveryList='日志查询',
  TrafficAnalytics='流量指标分析',
  TrafficList='流量异常分析',
  HTTP='HTTP',
  WithDropFrame='关联卡顿列表',
  FoomIssuesList='OOM问题列表',
  FoomAnalytics='OOM指标分析',
  DropFrameAnalytics='卡顿指标分析',
  DropFrameList='卡顿问题列表',
  DropFrameTree='卡顿树',
  MemoryAnalytics='内存指标分析',
  JavaLeakList='Java 内存泄漏',
  JavaMemoryDetail='Java 内存详情',
  MemoryDetail='内存详情',
  FdDetail='FD 详情',
  BadMalloc='大块内存分配',
  NativeDetail='Native 内存详情',
  BigPic='大图分析',
  LaunchAnalytics='启动指标分析',
  Tombstone='附件',
  LaunchIssues='启动个例',
  NetError='网络错误',
  UploadSymbolList = '上传符号表',
  AppDeliverConfig = '配置任务',
  CreateAlert='新建告警任务',
  InferredLabels='数据标记',
  IssuesDocCountPerDevice='发生次数/影响设备数',
  TagsInFilter='个例标签',
  MinAppVersionInFilter='版本范围',
  Remark='备注',
  MINUTE5='5分钟聚合',
  WEEK='按周聚合',
  MONTH='按月聚合',
  LogAnalyze='日志自动分析',
  IssueSplit='Issue拆分',
  RelatedMonitoring='联动监控',
  MainStack='聚类堆栈',
  AnrMsg='ANR_INFO',
  AnrTrace='ANR Trace',
  FDInfo='FD信息',
  ProcessInfo='进程信息',
  Scheduling='调度时序图',
  GCDetail='GC详情',
  MiniDump='minidump',
  Dimension='现场数据-自定义维度',
  Page='现场数据-页面追踪',
  QimeiCount='上报设备',
  userCount='上报用户',
  AddSection='添加分布',
  BatchCreate='批量提单',
  MemoryVcLeak='VC 内存泄漏',
  Track='高级搜索',
  MetircKit='MetircKit',
  Tapd='Tapd',
  Trace='现场数据的页面跟踪',
  SectionList='区间分布'
}
